import styled from "styled-components";
import { STYLE_CONSTS } from "~/src/styles/config.style";

export default styled.div`
  font-size: ${STYLE_CONSTS.FONT_MEDIUM};
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? STYLE_CONSTS.UNIT_10 : STYLE_CONSTS.UNIT_2};
  margin-top: ${({ marginTop }) => (marginTop ? STYLE_CONSTS.UNIT_4 : 0)};
`;
